// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HqPuh","border":"styles_border__5xwH4"};